import { render, staticRenderFns } from "./FormNotas.vue?vue&type=template&id=57f44ea9&"
import script from "./FormNotas.vue?vue&type=script&lang=js&"
export * from "./FormNotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports